import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { tjipPercentFilter } from '@tjip/vuejs';
import AppHypotheekdeelVue from './hypotheekdeel/AppHypotheekdeel.vue';
import AppOnderpandenVue from './onderpanden/AppOnderpanden.vue';
import AppHypotheekDataVue from './hypotheekdata/AppHypotheekData.vue';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import AppBerichtenVue from './berichten/AppBerichten.vue';
import { AppBootstrapMixin } from '@/mixins/AppBootstrapMixin';
import AppInBehandelingVue from './behandeling/AppInBehandeling.vue';

@Component({
  components: {
    'app-hypotheek-data': AppHypotheekDataVue,
    'app-hypotheekdeel': AppHypotheekdeelVue,
    'app-onderpanden': AppOnderpandenVue,
    'app-berichten': AppBerichtenVue,
    'app-in-behandeling': AppInBehandelingVue
  }
})
export default class AppHypotheek extends Mixins(AppFiltersMixin, AppHypotheekMixin, AppBootstrapMixin) {
  public showBouwdepotSucceeded = true;
  @Prop()
  public uploadBouwdepotSucceeded!: string;

  get allowBack(): boolean {
    return this.hypotheken && this.hypotheken.length > 1;
  }

  get renteDisplay(): string {
    if (this.hypotheek) {
      const min = this.hypotheek.minRente;
      const max = this.hypotheek.maxRente;
      return min === max
        ? tjipPercentFilter.call(this, min, { baseValue: 100 })
        : `${tjipPercentFilter.call(this, min, { baseValue: 100 })} - ${tjipPercentFilter.call(this, max, {
            baseValue: 100
          })}`;
    }
    return '';
  }

  mounted() {
    this.showBouwdepotSucceeded = this.uploadBouwdepotSucceeded === 'true';
  }
}
